/* ════════════════════════════════════════════════════════════════
   POSTERARTE · posterarte.analitica.js
   Eventos propios del escaparate.

   Hoy solo mide el CTA «LO QUIERO» de la tarjeta de producto. Ese boton
   lleva a la ficha igual que la tarjeta entera, asi que sin un evento con
   nombre propio sus clics quedan mezclados con todos los demas que llegan
   al mismo sitio y no se pueden distinguir.

   Se publica por Shopify.analytics.publish, que es la via que recogen los
   Custom Pixels. Y ademas se empuja a dataLayer SI existe: el 2026-08-25
   GA4 no estaba instalado en la tienda, y asi el dia que se conecte el
   evento ya esta puesto sin volver a tocar el tema.
   ════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  /* Un evento por CTA, con el nombre en el propio data-cta: lo-quiero,
     guardar, compartir. Asi anadir un boton nuevo no toca este fichero. */
  var PREFIJO = 'delanima_cta_';

  function posicionEnRejilla(cta) {
    var card = cta.closest('.pa-col-card');
    if (!card || !card.parentElement) return null;
    return Array.prototype.indexOf.call(card.parentElement.children, card) + 1;
  }

  function publicar(datos) {
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(datos.evento, datos);
      }
    } catch (e) { /* la analitica nunca puede romper la navegacion */ }

    try {
      if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push({ event: datos.evento, ...datos });
      }
    } catch (e) { /* idem */ }
  }

  document.addEventListener('click', function (e) {
    var cta = e.target.closest('[data-cta]');
    if (!cta) return;

    publicar({
      evento: PREFIJO + String(cta.dataset.cta).replace(/-/g, '_'),
      producto_id: cta.dataset.productoId || null,
      producto_handle: cta.dataset.productoHandle || null,
      producto_titulo: cta.dataset.productoTitulo || null,
      precio_desde: cta.dataset.precioDesde ? Number(cta.dataset.precioDesde) : null,
      moneda: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || null,
      contexto: cta.dataset.contexto || null,
      posicion: posicionEnRejilla(cta),
      plantilla: document.querySelector('main[data-template]')
        ? document.querySelector('main[data-template]').dataset.template
        : null
    });
    /* Sin preventDefault: el enlace sigue su camino. */
  }, true);
})();
